var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkerPolygonPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.29779 18.7035C4.45924 17.865 5.01523 16.1031 4.58867 15.0714C4.1457 14.0059 2.52148 13.14 2.52148 12.0007C2.52148 10.8613 4.1457 9.99544 4.58867 8.92995C5.01523 7.89909 4.45924 6.13633 5.29779 5.29779C6.13633 4.45924 7.89909 5.01523 8.92995 4.58867C10 4.1457 10.8613 2.52148 12.0007 2.52148C13.14 2.52148 14.0059 4.1457 15.0714 4.58867C16.1031 5.01523 17.865 4.45924 18.7035 5.29779C19.5421 6.13633 18.9861 7.89818 19.4126 8.92995C19.8556 10 21.4798 10.8613 21.4798 12.0007C21.4798 13.14 19.8556 14.0059 19.4126 15.0714C18.9861 16.1031 19.5421 17.865 18.7035 18.7035C17.865 19.5421 16.1031 18.9861 15.0714 19.4126C14.0059 19.8556 13.14 21.4798 12.0007 21.4798C10.8613 21.4798 9.99544 19.8556 8.92995 19.4126C7.89909 18.9861 6.13633 19.5421 5.29779 18.7035Z",
    stroke: "#42296E",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.834C12.6041 17.834 13.0938 17.3443 13.0938 16.7402C13.0938 16.1362 12.6041 15.6465 12 15.6465C11.3959 15.6465 10.9062 16.1362 10.9062 16.7402C10.9062 17.3443 11.3959 17.834 12 17.834Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 13.4583V12.7292C13.6112 12.7292 14.9173 11.5862 14.9173 10.1771C14.9173 8.76797 13.6112 7.625 12.0007 7.625C10.3901 7.625 9.08398 8.76797 9.08398 10.1771V10.5417",
    stroke: "#42296E",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkerPolygonPurple);
export default __webpack_public_path__ + "static/media/question_marker_polygon_purple.c58dbad2d6e0875ecad3ca653cffe99b.svg";
export { ForwardRef as ReactComponent };